import { combineReducers } from '@reduxjs/toolkit';
import complaintAppComplaint from './complaint/reducers';
import complaintTypeReducer from './complaintType/reducer';
import appDetailsReducer from './appDetails/reducer';
import { rolesSlice } from './Roles/reducer';
import WorkflowReducer from './Workflow/reducer';
import queryManagement from './querymanagement/reducers';
import status from './status/reducers';
import createComplaint from './createComplaint/reducers';
import changeStatus from './changestatus/reducers';

const rootReducer = combineReducers({
  complaintAppComplaint,
  complaintType: complaintTypeReducer,
  appDetails: appDetailsReducer,
  workflow: WorkflowReducer,
  roles: rolesSlice.reducer,
  queryManagement,
  status,
  createComplaint,
  changeStatus,
});

export default rootReducer;
